/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyListItem
 */
export interface AgencyListItem {
    /**
     * 
     * @type {string}
     * @memberof AgencyListItem
     */
    id?: string;
    /**
     * 
     * @type {object}
     * @memberof AgencyListItem
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof AgencyListItem
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyListItem
     */
    abtaNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyListItem
     */
    label?: string | null;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AgencyListItem
     */
    group?: GuidIdAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof AgencyListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyListItem
     */
    allowEdit?: boolean;
}

export function AgencyListItemFromJSON(json: any): AgencyListItem {
    return AgencyListItemFromJSONTyped(json, false);
}

export function AgencyListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'abtaNumber': !exists(json, 'abtaNumber') ? undefined : json['abtaNumber'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'group': !exists(json, 'group') ? undefined : GuidIdAndLabelFromJSON(json['group']),
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function AgencyListItemToJSON(value?: AgencyListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'abtaNumber': value.abtaNumber,
        'label': value.label,
        'group': GuidIdAndLabelToJSON(value.group),
        'disabled': value.disabled,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'allowEdit': value.allowEdit,
    };
}


